import React, {useState, useContext} from 'react';
import {  useLoaderData, useActionData, Form, redirect, json, Link, useSubmit } from 'react-router-dom';

import {getTableForm} from '../utils/api';
import { updateUserProfile } from '../utils/api';
import { getUserProfile } from '../utils/api';

import MenuContext from '../store/MenuContext';

import FormHelper from '../components/UI/FormHelper';
import RegisterClasses from '../components/Register/Register.module.css';

const RegHeader = () => {
	const menuTheme = useContext(MenuContext);

  return (
	 <div>		  
		 <h2 className={RegisterClasses.testTitle}>
		  User Profile Edit
        </h2>
      <p >
	      Fill out all required (*) fields prior to clicking save.
      </p>
    </div>
  );
};
export const UserProfileEdit = (props) => {
		const submit = useSubmit();
		const loaderdata=useLoaderData();
		const actionData=useActionData();
		const tableForm=loaderdata[0];
		const UP=loaderdata[1];
		console.log(UP);
		const [formError,setFormError] = useState({});
		const tfHandler = (tferror) => {
			let newtfError={...tferror}
			setFormError(newtfError);
		};
		const handleSubmit = async (event) => {
			event.preventDefault();
			if(Object.keys(formError).length ===0) {
				await submit(event.currentTarget, { method: 'post' });
				//handle errors.....
			}
		};
		const menuTheme = useContext(MenuContext);

    return( 
		<div className={RegisterClasses.testInfo}>
			  <div className={RegisterClasses.testInfoContent}>
				 <Form method='post'>
					<RegHeader />
					<FormHelper TF={tableForm} data={UP} onTF={tfHandler}/>
					  {actionData?.errors && <p>{actionData.errors}</p>}	
					  {actionData?.message && <p>{actionData.message}</p>}
					  <div className={RegisterClasses.buttonArea}> 
						<button className='buttonDarkBlue' onClick={handleSubmit}>	Save  </button>
					  </div>
				  </Form>
				</div>
		</div>
	);
};	

const UserProfile = (props) => {
		const UP=props.data;

    return( 
		<div>
				{UP.PatientFirstName} {UP.PatientLastName}<br />
				{UP.Address}<br />
				{UP.City}, {UP.State}  {UP.Zip}<br />
				Phone: {UP.HomePhone}<br />
				Email: {UP.PatEmail}<br />
				DOB: {UP.DOB}<br/>
				<Link to="../UserProfileEdit" className='buttonDarkBlue'>Update User Profile</Link>
			</div>
	);
};

export default UserProfile;

export async function tfloader() {
    const response = await getTableForm('DTC:Patient','UserProfile');
	const resData = await response;
		return resData;
}

export async function userProfileLoader() {
    const response = await getUserProfile(sessionStorage.getItem('Labtestid'));
	const resData = await response;
		return resData;
}
export  async function loader() {
	return Promise.all([tfloader(),userProfileLoader()]);
}
	
export async function action({ request, params }) {
  const data = await request.formData();

  const regData = {
    FirstName: data.get('FirstName'),
	LastName: data.get('LastName'),
    Address: data.get('Address'),
    City: data.get('City'),
    State: data.get('State'),
	Zip: data.get('Zip'),
    Email: data.get('Email'),
    DOB: data.get('DOB'),
    Phone: data.get('Phone'),
	County: data.get('County'),
	Race: data.get('Race'),
	Ethnicity: data.get('Ethnicity'),
	Gender: data.get('Gender'),
	account: {username: data.get('Username'),
		password: data.get('new-password')}
  };
	const response = await updateUserProfile(regData);
		var messages = {};
  		if (response.status===500) {
			throw json(
			  { message: 'Could not update user profile.' },
			  {
				status: 500,
			  }
			);
		  }
		if (response.status===400) {
			messages.errors="Invalid data";
		}			
		if (response.ok) {
			if (response.status ===201) {
					messages.message="User profile updated."
			}
			return redirect('../cart?review=1');
		}
  return messages;
		 
}	
